import { render, staticRenderFns } from "./DetailPacking.vue?vue&type=template&id=90d0cf4a&"
import script from "./DetailPacking.vue?vue&type=script&lang=js&"
export * from "./DetailPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports